import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// import { CompanySettingsService } from 'src/app/services/company-settings.service';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

   appConfig: any;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    let mythis = this;
    return this.http.get('/assets/data/appConfig.json')
      .toPromise()
      .then(data => {
        mythis.appConfig = data;
      });
  }

  // This is an example property ... you can make it however you want.
  get apiBaseUrl() {

    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.apiBaseUrl;
  }

  get dateFormat() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }


    let settings: any = localStorage.getItem('settings');

    if(settings && settings != 'null') {
      settings = JSON.parse(settings);

      let value = settings.dateFormat ? settings.dateFormat : this.appConfig.dateFormat;
      return value;
    }
    return this.appConfig.dateFormat;
  }

  get moneyFormat() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    // this.settings.GetClientSettings('')
    let settings: any = localStorage.getItem('settings');

    if(settings && settings != 'null') {
      settings = JSON.parse(settings);

      let value = settings.moneyFormat ? settings.moneyFormat : this.appConfig.moneyFormat;
      return value;
    }

    return this.appConfig.moneyFormat;
  }

  get estimateDefault() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }


    let settings: any = localStorage.getItem('settings');

    if(settings && settings != 'null') {
      settings = JSON.parse(settings);

      let value = settings.estimateidDefault ? settings.estimateidDefault : this.appConfig.estimateidDefault;
      return value;
    }
    return null;
  }
  
  get websocketserverURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.websocketserverURL;
  }

  get cubeAIserverURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.cubeAIserverURL;
  }

  get videoDashboardSelected() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.videoDashboardSelected;
  }

  get videoDashboardUnSelected() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.videoDashboardUnSelected;
  }

  get reportingURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.reportingURL;
  }

  get LinkGettingStarted() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.LinkGettingStarted;
  }

  get LinkCubeFlow() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.LinkCubeFlow;
  }

  get LinkWhatsNew() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.LinkWhatsNew;
  }

  get dashboardURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    // debugger;
    if (this.UseNewDashboard){
      return this.appConfig.newdashboardURL;
    }
    else {
      return this.appConfig.dashboardURL;
    }    
  }

  get newdashboardURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    // debugger;
    return this.appConfig.newdashboardURL;
  }
  
  get UseNewDashboard() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    try{
      return this.appConfig.UseNewDashboard == "true";
    }
    catch (ex){
      return false;
    }
    
  }

  get currencyData() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.currencyData;
  }

  get dateFormatData() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.dateFormatData;
  }

  get apiMasterVendorURL(){
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.apiMasterVendorUrl;
  }

  get ecomerceconcode() {

    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.ecomerceconcode;
  }
}
